import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useForm, useWatch } from 'react-hook-form';
import { DialogContent, DialogActions } from '@mui/material';
import { useMembers } from '@app/api/members/useMembers';
import { fetchAllGroups } from '@app/store/slices/myTeamSlice';
import { ThemeButton } from '@shared/ui/buttons';
import Note from '@shared/ui/messages/Note';
import {
  MemberRoleView,
  BasicSelectInput,
  CardsActionPicker,
} from '@shared/ui/forms/inputs';
import { roles } from '@shared/static/roles';
import { getTotalCards } from '@utils/helpers';
import { validateServerErrors } from '@utils/validation';

//todo: заморозка тим лида
// если тим лид, то либо заблокировать все карты во всех группах, либо передать карты только администратору

export default function FreezeMemberDialog({ close, data }) {
  const [loading, setLoading] = useState(false);
  const { freezeMember } = useMembers();
  const { allGroups } = useSelector((state) => state.my_team);

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const {
    control,
    handleSubmit,
    formState: { errors },
    setError,
  } = useForm({
    defaultValues: {
      cards_action: 'transfer',
      cards_transfer_user_id: null,
    },
  });

  const isTeamLead = data.group_role === roles.TEAM_LEAD;

  useEffect(() => {
    if (!isTeamLead) {
      dispatch(fetchAllGroups());
    }
  }, [isTeamLead]);

  const cardsActionWatch = useWatch({ control, name: 'cards_action' });

  const hasCards = getTotalCards(data) > 0;

  // if (group) return group;
  // if (group) return group.users?.filter((x) => x.id !== data.id);
  const cardOwners = allGroups
    .find((group) => data.groups?.[0]?.id === group.id)
    ?.users?.filter((x) => x.id !== data.id);

  async function onSubmit(formData) {
    const payload = {
      user_id: data.id,
      cards_action: formData.cards_action,
      ...(formData.cards_action === 'transfer' && {
        cards_transfer_user_id: formData.cards_transfer_user_id,
      }),
    };
    setLoading(true);
    try {
      const res = await freezeMember(payload);
      if (res) close();
    } catch (error) {
      validateServerErrors(setError, error);
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <DialogContent>
        <div className="form">
          <p>{t('are_sure_member_freeze')}</p>
          <MemberRoleView member={data} />
          {hasCards && (
            <CardsActionPicker
              isTeamLead={isTeamLead}
              type="freezeMember"
              control={control}
              name="cards_action"
              error={errors.cards_action}
            />
          )}
          {cardsActionWatch === 'transfer' && hasCards && (
            <BasicSelectInput
              control={control}
              name="cards_transfer_user_id"
              label={t('new_owner')}
              data={isTeamLead ? [] : cardOwners}
              error={errors.cards_transfer_user_id}
              icon="user-input"
              placeholder={t('Administrator')}
              searchable
              disabled={isTeamLead}
            />
          )}
        </div>
        <Note
          marginTop
          type="warning"
          title={t('important')}
          content={t('member_freeze_note')}
        />
      </DialogContent>
      <DialogActions>
        <div className="btns-toolbar">
          <ThemeButton
            startIcon="freeze"
            loading={loading}
            onClick={handleSubmit(onSubmit)}
          >
            {t('freeze')}
          </ThemeButton>
          <ThemeButton onClick={close} appearance="secondary">
            {t('no_cancel')}
          </ThemeButton>
        </div>
      </DialogActions>
    </>
  );
}
